console.log("Riftbound Grid Adapter loaded");

(function (window, document) {
  "use strict";

  var config = window.RiftboundCollectionConfig || {};
  var COLLECTION_INSTANCE_ID =
    "riftbound-collection";

  var SEARCH_INSTANCE_ID =
    "riftbound-search";

  /*
    This is copied from the current Pokemon adapter.
    If Notify Me uses a different Klaviyo form for Riftbound,
    replace this later.
  */
  var FORM_ID = "W2nZC4";

  var registeredInstance = null;
  var collectionNavigation = null;

  // =========================================================
  // HELPERS
  // =========================================================

  function normalizeText(value) {
    return String(value == null ? "" : value).trim();
  }

  function normalizeLower(value) {
    return normalizeText(value).toLowerCase();
  }

  function escapeRegExp(value) {
    return String(value || "")
      .replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function normalizeCollectorNumber(value) {
    return normalizeText(value)
      .split("/")
      .map(function (part) {
        var cleaned = part.replace(
          /^0+(?=\d)/,
          ""
        );

        return cleaned || "0";
      })
      .join("/");
  }

  function formatCollectorNumber(value) {
    var number =
        normalizeCollectorNumber(value);

    if (!number) {
        return "";
    }

    return /[\/-]/.test(number)
        ? number
        : "#" + number;
    }

  function getRiftboundTitleParts(variant) {
    var title = normalizeText(
      variant && variant.title
    );

    var finish = normalizeText(
      variant && variant.finish
    );

    var cardNumber = normalizeText(
      variant && variant.number
    );

    if (!title) {
      return {
        name: "",
        details: ""
      };
    }

    /*
      Let the shared SinglesGrid parser handle:
      - separating the card name
      - extracting trailing (...) details
      - converting commas to " · "
    */
    var parsed =
      window.SinglesGrid.finish.parseTitle(
        title,
        finish,
        {}
      );

    var name = normalizeText(
      parsed && parsed.name
    );

    var details = normalizeText(
      parsed && parsed.details
    );

    /*
      Riftbound-specific cleanup:
      finish descriptions belong in the finish badge,
      not in the title-extra line.

      Removes:
        Foil
        Normal

      Keeps:
        Alternate Art
        SP
        etc.
    */
    if (details) {
      details = details
        .split(/\s*·\s*/)
        .map(function (detail) {
          return normalizeText(detail);
        })
        .filter(function (detail) {
          var normalized =
            normalizeLower(detail)
              .replace(/[-–—]/g, " ")
              .replace(/\s+/g, " ")
              .trim();

          if (!normalized) {
            return false;
          }

          if (
            normalized === "normal" ||
            normalized === "nonfoil" ||
            normalized === "non foil"
          ) {
            return false;
          }

          if (
            normalized.indexOf("foil") !== -1 ||
            normalized.indexOf("holo") !== -1
          ) {
            return false;
          }

          return true;
        })
        .join(" · ");
    }

    /*
      Remove the collector number from the card name
      if Shopify also included it in the title.

      The optional # also prevents:
        Card Name #327
      from becoming:
        Card Name #327 · #327
    */
    if (cardNumber) {
      var numberCandidates = [
        cardNumber,
        normalizeCollectorNumber(
          cardNumber
        )
      ].filter(function (
        value,
        index,
        values
      ) {
        return (
          value &&
          values.indexOf(value) === index
        );
      });

      numberCandidates.forEach(
        function (numberValue) {
          name = name.replace(
            new RegExp(
              "\\s+#?" +
              escapeRegExp(
                numberValue
              ) +
              "$",
              "i"
            ),
            ""
          ).trim();
        }
      );
    }

    return {
      name: name,
      details: details
    };
  }

  function normalizeRiftboundFinish(value) {
    var finish = normalizeLower(value)
        .replace(/[-–—]/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    if (!finish) {
        return "";
    }

    if (
        finish === "normal" ||
        finish === "nonfoil" ||
        finish === "non foil"
    ) {
        return "Normal";
    }

    return "Foil";
  }

  function getFinishClass(value) {
    return normalizeLower(value)
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function isFoilFinish(value) {
    return (
      normalizeRiftboundFinish(value) ===
      "Foil"
    );
  }

  function joinListDetails(
    values,
    escapeHtml
  ) {
    return values
      .filter(Boolean)
      .map(function (value) {
        return escapeHtml(value);
      })
      .join(
        '<span class="singles-list-detail-divider" aria-hidden="true"> • </span>'
      );
  }

    // =========================================================
  // GRID REGISTRATION
  // =========================================================

  function registerRiftboundGrid() {
    if (registeredInstance) {
      return registeredInstance;
    }

    if (
      !window.SinglesGrid ||
      !window.SinglesGrid.version
    ) {
      return null;
    }

    var api = window.SinglesGrid;
    var escapeHtml =
      api.helpers.escapeHtml;

    var collectionRoot =
      document.querySelector(
        '[data-singles-collection][data-game="riftbound"]'
      );

    var searchRoot =
      document.querySelector(
        '[data-singles-search-results][data-game="riftbound"]'
      );

    var isSearchPage =
      !collectionRoot &&
      Boolean(searchRoot);

    if (
      !collectionRoot &&
      !searchRoot
    ) {
      return null;
    }

    var rootSelector =
      isSearchPage
        ? '[data-singles-search-results][data-game="riftbound"]'
        : '[data-singles-collection][data-game="riftbound"]';  

    // =======================================================
    // RIFTBOUND DISPLAY HELPERS
    // =======================================================

    function renderSetCode(variant) {
      var setCode = normalizeText(
        variant && variant.set_code
      );

      if (!setCode) {
        return "";
      }

      return (
        '<span class="riftbound-card-set-code" aria-hidden="true">' +
          escapeHtml(
            setCode.toUpperCase()
          ) +
        "</span>"
      );
    }

    function renderFinishBadge(
      variant,
      mode
    ) {
      var finish =
        normalizeRiftboundFinish(
          variant && variant.finish
        );

      if (
        !finish ||
        finish === "Normal"
      ) {
        return "";
      }

      return api.render.finishBadge(
        {
          text: finish,

          cls:
            "badge-regular finish-" +
            getFinishClass(finish)
        },
        {
          mode: mode,

          className:
            "riftbound-finish-badge"
        }
      );
    }

    function renderGridMetadata(
      variant,
      titleParts
    ) {
      var number =
        normalizeCollectorNumber(
          variant && variant.number
        );

      var details = [];

      if (
        titleParts &&
        titleParts.details
      ) {
        details.push(
          titleParts.details
        );
      }

      if (number) {
        details.push(
          formatCollectorNumber(number)
        );
      }

      return api.render
        .gridTitleDetails(
          details.join(" · ")
        );
    }

    function renderGridSet(
      variant
    ) {
      var setName = normalizeText(
        variant && variant.set_name
      );

      var setCodeHtml =
        renderSetCode(variant);

      if (
        !setName &&
        !setCodeHtml
      ) {
        return "";
      }

      return (
        '<div class="singles-grid-set riftbound-grid-set" data-riftbound-set-row>' +

          setCodeHtml +

          (
            setName
              ? (
                  '<span data-riftbound-set-name>' +
                    escapeHtml(setName) +
                  "</span>"
                )
              : ""
          ) +

        "</div>"
      );
    }

    function renderListSet(
      variant
    ) {
      var setName = normalizeText(
        variant && variant.set_name
      );

      var setCodeHtml =
        renderSetCode(variant);

      if (
        !setName &&
        !setCodeHtml
      ) {
        return "";
      }

      return (
        setCodeHtml +

        (
          setName
            ? (
                '<span data-riftbound-list-set-name>' +
                  escapeHtml(setName) +
                "</span>"
              )
            : ""
        )
      );
    }

    function renderListMetadata(
      variant
    ) {
      var typeDetails = [];
      var propertyDetails = [];

      var types = normalizeText(
        variant && variant.types
      );

      var subtypes = normalizeText(
        variant && variant.subtypes
      );

      var colors = normalizeText(
        variant && variant.colors
      );

      var rarity = normalizeText(
        variant && variant.rarity
      );

      if (types) {
        typeDetails.push(types);
      }

      if (subtypes) {
        typeDetails.push(subtypes);
      }

      if (colors) {
        propertyDetails.push(colors);
      }

      if (rarity) {
        propertyDetails.push(rarity);
      }

      var html = "";

      if (typeDetails.length) {
        html +=
          '<div class="singles-list-type-line" data-riftbound-list-type-line>' +

            joinListDetails(
              typeDetails,
              escapeHtml
            ) +

          "</div>";
      }

      if (propertyDetails.length) {
        html +=
          '<div class="singles-list-properties" data-riftbound-list-properties>' +

            joinListDetails(
              propertyDetails,
              escapeHtml
            ) +

          "</div>";
      }

      return html;
    }

        // =======================================================
    // CARD RENDERERS
    // =======================================================

    function renderRiftboundGridCard(
      card,
      selected,
      instance
    ) {
      var titleParts =
        getRiftboundTitleParts(
          selected
        );

      var productUrl =
        normalizeText(
          selected.product_url
        ) ||
        (
          "/products/" +
          encodeURIComponent(
            card.key
          )
        );

      return api.render.gridCard(
        card,
        selected,
        instance,
        {
          title:
            titleParts.name,

          titleClass:
            "riftbound-grid-title",

          productUrl:
            productUrl,

          imageUrl:
            selected.img_url,

          imageAlt:
            selected.title ||
            titleParts.name,

          isFoil:
            isFoilFinish(
              selected.finish
            ),

          titleExtraHtml:
            renderGridMetadata(
              selected,
              titleParts
            ),

          finishBadgeHtml:
            renderFinishBadge(
              selected,
              "grid"
            ),

          setRowHtml:
            renderGridSet(
              selected
            ),

          formId:
            FORM_ID
        }
      );
    }

    function renderRiftboundListCard(
      card,
      selected,
      instance
    ) {
      var titleParts =
        getRiftboundTitleParts(
          selected
        );

      var productUrl =
        normalizeText(
          selected.product_url
        ) ||
        (
          "/products/" +
          encodeURIComponent(
            card.key
          )
        );

      var collectorNumber =
        normalizeCollectorNumber(
          selected.number
        );

      var titleDetailParts = [];

      if (titleParts.details) {
        titleDetailParts.push(
          titleParts.details
        );
      }

      if (collectorNumber) {
        titleDetailParts.push(
          formatCollectorNumber(
              collectorNumber
          )
        );
      }

      var titleDetailsHtml =
        titleDetailParts.length
          ? (
              '<span data-riftbound-list-number>' +
                escapeHtml(
                  titleDetailParts.join(
                    " · "
                  )
                ) +
              "</span>"
            )
          : "";

      return api.render.listCard(
        card,
        selected,
        instance,
        {
          title:
            titleParts.name,

          productUrl:
            productUrl,

          imageUrl:
            selected.img_url,

          imageAlt:
            selected.title ||
            titleParts.name,

          isFoil:
            isFoilFinish(
              selected.finish
            ),

          finishBadgeHtml:
            renderFinishBadge(
              selected,
              "list"
            ),

          titleDetailsHtml:
            titleDetailsHtml,

          setHtml:
            renderListSet(
              selected
            ),

          metadataHtml:
            renderListMetadata(
              selected
            ),

          formId:
            FORM_ID
        }
      );
    }

    function updateRiftboundCardVariant(
      cardElement,
      card,
      variant,
      instance
    ) {
      if (
        cardElement.hasAttribute(
          "data-singles-list-card"
        )
      ) {
        api.render
          .updateListCardVariant(
            cardElement,
            variant,
            {
              formId:
                FORM_ID
            }
          );

        return;
      }

      api.render
        .updateGridCardVariant(
          cardElement,
          variant,
          {
            formId:
              FORM_ID
          }
        );
    }

        // =======================================================
    // SHARED GRID CONFIGURATION
    // =======================================================

    registeredInstance =
      api.create({
        id:
          isSearchPage
            ? SEARCH_INSTANCE_ID
            : COLLECTION_INSTANCE_ID,

        game:
          "riftbound",

        storageNamespace:
          isSearchPage
            ? "riftbound-search"
            : "riftbound",

        root:
          rootSelector,

        grid:
          "[data-singles-grid]",

        loading:
          "[data-singles-grid-loading]",

        rowsElementId:
          isSearchPage
            ? "singles-search-cardjson"
            : "",

        jsonUrl:
          isSearchPage
            ? null
            : config.jsonUrl,

        productCount:
          isSearchPage
            ? 0
            : config.productCount,

        autoLoad:
          !isSearchPage,

        defaultAvailability:
          isSearchPage
            ? "all"
            : (
                config.defaultAvailability ||
                "instock"
              ),

        stockFirstWhenAll:
          isSearchPage,

        persistAvailability:
          false,

        clearAvailability:
          "all",

        defaultView:
          config.defaultView ||
          "grid",

        defaultSort:
          isSearchPage
            ? "best-selling"
            : (
                config.defaultSort ||
                "manual"
              ),

        allowedSorts: [
          "manual",
          "best-selling",
          "title-ascending",
          "price-ascending",
          "price-descending"
        ],

        syncSortToUrl:
          !isSearchPage, 

        emptyMessage:
          "No matching Riftbound cards were found.",

        errorHeading:
          "Riftbound cards could not be loaded.",

        filterDefinitions: [

          // =================================================
          // FINISH
          // =================================================

          {
            key: "finish",
            label: "Finish",
            split: false,

            options: [
                "Normal",
                "Foil"
            ],

            getValues: function (card) {
                var values = [];

                card.variants.forEach(function (variant) {
                var finish =
                    normalizeRiftboundFinish(
                    variant.finish
                    );

                if (finish) {
                    values.push(finish);
                }
                });

                return values;
            }
          },


          // =================================================
          // RARITY
          // =================================================

          {
            key: "rarity",
            field: "rarity",
            label: "Rarity",
            split: false,

            options: [
                "Common",
                "Uncommon",
                "Rare",
                "Epic",
                "Showcase"
            ]
          },


          // =================================================
          // COLOR
          // =================================================

          {
            key: "color",
            field: "colors",
            label: "Domain",

            options: [
                "Fury",
                "Calm",
                "Body",
                "Mind",
                "Order",
                "Chaos",
                "Colorless"
            ],

            separator:
                /\s*[,/|]\s*/
          },


          // =================================================
          // CARD TYPE
          // =================================================

          {
            key: "type",
            field: "types",
            label: "Card Type",

            options: [
                "Battlefield",
                "Gear",
                "Legend",
                "Rune",
                "Spell",
                "Unit"
            ],

            separator:
                /\s*[,/|]\s*/
          },


          // =================================================
          // SUBTYPE
          // =================================================

          {
            key: "subtype",
            field: "subtypes",
            label: "Subtype",
            separator: /\s*[,/|]\s*/,
            control: "search-multiselect",
            placeholder: "Search or select a subtype...",
            emptyText: "No matching subtypes",
            initialSuggestions: 8,
            maxSuggestions: 50
          }
        ],

        renderer: {
          renderGridCard:
            renderRiftboundGridCard,

          renderListCard:
            renderRiftboundListCard,

          updateCardVariant:
            updateRiftboundCardVariant
        }
      });


    /*
      Use our cleaned Riftbound card title for
      card-name searching and Name A-Z sorting.
    */
    registeredInstance.getCardTitle =
      function (card) {
        var selected =
          this.getSelectedVariant(card) ||
          (
            card &&
            Array.isArray(
              card.variants
            )
              ? card.variants[0]
              : null
          ) ||
          {};

        return getRiftboundTitleParts(
          selected
        ).name;
      };  

    // =======================================================
    // INITIALIZATION + COLLECTION NAVIGATION
    // =======================================================

    registeredInstance
      .initialize()
      .then(function (instance) {

        if (isSearchPage) {
          console.log(
            "Riftbound search rows loaded:",
            instance.state.rows.length
          );

          console.log(
            "Riftbound search products grouped:",
            instance.state.cards.length
          );

          return instance;
        }

        if (
          typeof api
            .createCollectionNavigation ===
          "function"
        ) {
          collectionNavigation =
            api.createCollectionNavigation({
              root:
                instance.root,

              rootSelector:
                '[data-singles-collection][data-game="riftbound"]',

              linkSelector:
                "[data-singles-collection-link]",

              gridInstance:
                instance,

              preserveSortOnLinks:
                true,

              reloadOnSort:
                true,

              fallbackOnError:
                true
            });
        }

        console.log(
          "Riftbound collection rows loaded:",
          instance.state.rows.length
        );

        console.log(
          "Riftbound collection products grouped:",
          instance.state.cards.length
        );

        return instance;
      })
      .catch(function (error) {
        console.error(
          "Riftbound grid initialization failed:",
          error
        );
      });


    // =======================================================
    // SMALL RIFTBOUND API
    // =======================================================

    window.RiftboundGrid = {

      getInstance:
        function () {
          return registeredInstance;
        },

      getCollectionNavigation:
        function () {
          return collectionNavigation;
        },

      render:
        function (rows) {
          if (!registeredInstance) {
            return;
          }

          registeredInstance
            .setRows(
              Array.isArray(rows)
                ? rows.slice()
                : []
            );

          registeredInstance
            .setLoading(false);
        },

      getState:
        function () {
          return registeredInstance
            ? registeredInstance.state
            : null;
        }
    };


    return registeredInstance;
  }


  // =========================================================
  // STARTUP
  // =========================================================

  function initialize() {
    var instance =
      registerRiftboundGrid();

    if (
      !instance &&
      document.readyState !==
        "loading"
    ) {
      console.error(
        "Riftbound grid could not start because js-theme-singles-grid.js was not loaded first."
      );
    }
  }


  if (
    window.SinglesGrid &&
    window.SinglesGrid.version
  ) {
    initialize();

  } else {
    document.addEventListener(
      "singles:grid:ready",
      initialize,
      {
        once: true
      }
    );

    if (
      document.readyState ===
      "loading"
    ) {
      document.addEventListener(
        "DOMContentLoaded",
        initialize,
        {
          once: true
        }
      );

    } else {
      window.setTimeout(
        initialize,
        0
      );
    }
  }

})(window, document);